import axios from "axios";
import { api } from "./api_route";


//Case Primary Information Routes --> Asset Details (Property)

// =========== GET ALL PROPERTIES BY CASE ID ===========
export const getAllPropertiesByCaseId = async (caseDetailsID) => {
    try {
        const response = await axios.get(
            `${api}/case/casePropertyDetails/all/${caseDetailsID}`
        );

        return {
            success: true,
            data: response.data.data || [],
            assetOwnedBy: response.data.assetOwnedBy || '',
            count: response.data.count || 0,
            message: response.data.message || "Properties fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching properties:", error);
        return {
            success: false,
            data: [],
            count: 0,
            message: error.response?.data?.message || "Failed to fetch properties",
            error: error.response?.data?.error || error.message,
        };
    }
};


// =========== GET SINGLE PROPERTY BY ID ===========
export const getPropertyById = async (propertyID) => {
    try {
        const response = await axios.get(
            `${api}/case/casePropertyDetails/${propertyID}`
        );

        return {
            success: true,
            data: response.data.data,
            // message: response.data.message || "Property fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching property:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to fetch property",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== CREATE NEW PROPERTY ===========
export const createProperty = async (propertyData) => {
    try {
        const response = await axios.post(
            `${api}/case/casePropertyDetails`,
            propertyData
        );

        

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Property created successfully",
        };
    } catch (error) {
        console.error("Error creating property:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to create property",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== UPDATE PROPERTY ===========
export const updateProperty = async (propertyID, propertyData) => {
    try {
        const response = await axios.put(
            `${api}/case/casePropertyDetails/${propertyID}`,
            propertyData
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Property updated successfully",
        };
    } catch (error) {
        console.error("Error updating property:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to update property",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== DELETE PROPERTY ===========
export const deleteProperty = async (propertyID, updatedBy) => {
    try {
        const response = await axios.delete(
            `${api}/case/casePropertyDetails/${propertyID}`,
            { data: { updatedBy } }
        );

        return {
            success: true,
            message: response.data.message || "Property deleted successfully",
        };
    } catch (error) {
        console.error("Error deleting property:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Failed to delete property",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== SEARCH PROPERTIES ===========
export const searchProperties = async (caseDetailsID, searchCriteria) => {
    try {
        const response = await axios.post(
            `${api}/case/casePropertyDetails/search/${caseDetailsID}`,
            searchCriteria
        );

        return {
            success: true,
            data: response.data.data || [],
            count: response.data.count || 0,
            message: response.data.message || "Search completed successfully",
        };
    } catch (error) {
        console.error("Error searching properties:", error);
        return {
            success: false,
            data: [],
            count: 0,
            message: error.response?.data?.message || "Failed to search properties",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== BULK CREATE PROPERTIES ===========
export const bulkCreateProperties = async (propertiesData) => {
    try {
        const response = await axios.post(
            `${api}/case/casePropertyDetails/bulk`,
            { properties: propertiesData }
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Properties created successfully",
        };
    } catch (error) {
        console.error("Error creating bulk properties:", error);
        return {
            success: false,
            data: [],
            message: error.response?.data?.message || "Failed to create properties",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== GET PROPERTIES WITH PAGINATION ===========
export const getPropertiesWithPagination = async (caseDetailsID, page = 1, limit = 10) => {
    try {
        const response = await axios.get(
            `${api}/case/casePropertyDetails/paginated/${caseDetailsID}`,
            { params: { page, limit } }
        );

        return {
            success: true,
            data: response.data.data || [],
            pagination: response.data.pagination || {},
            message: response.data.message || "Properties fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching properties with pagination:", error);
        return {
            success: false,
            data: [],
            pagination: {},
            message: error.response?.data?.message || "Failed to fetch properties",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== EXPORT PROPERTIES TO EXCEL ===========
export const exportPropertiesToExcel = async (caseDetailsID) => {
    try {
        const response = await axios.get(
            `${api}/case/casePropertyDetails/export/${caseDetailsID}`,
            { responseType: "blob" }
        );

        return {
            success: true,
            data: response.data,
            message: "Export successful",
        };
    } catch (error) {
        console.error("Error exporting properties:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to export properties",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== HELPER FUNCTIONS ===========


export const formatPropertyData = (data) => {
    const formatted = { ...data };


    if (Array.isArray(formatted.propertyAttachment)) {
        formatted.propertyAttachment = formatted.propertyAttachment.join(",");
    }


    const formatDate = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
            return date.toISOString().split("T")[0];
        }
        return date;
    };


    if (formatted.caseDetailsID && !formatted.caseRowID) {
        formatted.caseRowID = formatted.caseDetailsID;
    }

    formatted.propertyRegisteredDocumentDate = formatDate(formatted.propertyRegisteredDocumentDate);

    return formatted;
};


export const parseAttachmentIds = (attachmentField) => {
    if (!attachmentField) {
        return [];
    }
    if (Array.isArray(attachmentField)) {
        return attachmentField;
    }
    if (typeof attachmentField !== 'string') {
        return [];
    }
    if (attachmentField.trim() === "") {
        return [];
    }
    return attachmentField
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");
};


export const validatePropertyData = (data) => {
    const errors = {};

    if (!data.caseDetailsID) {
        errors.caseDetailsID = "Case ID is required";
    }

    if (!data.assetClassification) {
        errors.assetClassification = "Asset Classification is required";
    }



    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
};


export const propertyFilesDownload = async (values) => {
    try {
        const response = await axios.get(`${api}/documents/asset/property/${values}`, {
            responseType: "blob",
        });

        return response.data;
    } catch (error) {
        return [];
    }
};
